import * as yup from 'yup';

import {
  FORM_KEYS,
  // NO_OF_CHARS
} from 'shared/constant';

const { COUNTRY_TAX } = FORM_KEYS;

const countryTaxFieldsSchema = (intl, elementName, isTin, reasonOption) => {
  switch (elementName) {
    case COUNTRY_TAX.COUNTRY_JURISDICTION:
      return yup.object().shape({
        [COUNTRY_TAX.COUNTRY_JURISDICTION]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      });
    case COUNTRY_TAX.IS_TIN:
      return yup.object().shape({
        [COUNTRY_TAX.IS_TIN]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      });
    case COUNTRY_TAX.TIN:
      return yup.object().shape({
        [COUNTRY_TAX.TIN]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (isTin === intl.formatMessage({ id: 'yes' }) && !value) return false;
              return true;
            },
          ),
      });
    case COUNTRY_TAX.REASON_OPTION:
      return yup.object().shape({
        [COUNTRY_TAX.REASON_OPTION]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (isTin === intl.formatMessage({ id: 'no' }) && !value) return false;
              return true;
            },
          ),
      });
    case COUNTRY_TAX.REASON_TIN_NOT_ISSUED:
      return yup.object().shape({
        [COUNTRY_TAX.REASON_TIN_NOT_ISSUED]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (isTin === intl.formatMessage({ id: 'no' }) && reasonOption === 'REASON-B' && !value) return false;
              return true;
            },
          ),
      });
    default:
      return null;
  }
};

// , isTin, reasonOption
const countryTaxListSchema = (intl, countryTax) => yup.object().shape({
  countryTax: yup.array(
    yup.object().shape({
      [COUNTRY_TAX.COUNTRY_JURISDICTION]: yup
        .string()
        .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      [COUNTRY_TAX.IS_TIN]: yup
        .string()
        .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      [COUNTRY_TAX.TIN]: yup
        .string()
        .test(
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          () => {
            // if (countryTax.isTin === intl.formatMessage({ id: 'yes' }) && !value) return false;
            if (countryTax.filter(x => x.isTin === intl.formatMessage({ id: 'yes' }) && x.tin === '').length === 1) {
              return false;
            }

            return true;
          },
        ),
      [COUNTRY_TAX.REASON_OPTION]: yup
        .string()
        .test(
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          () => {
            if (countryTax.filter(x => x.isTin === intl.formatMessage({ id: 'no' }) && x.reasonOption === '').length === 1) return false;
            return true;
          },
        ),
      [COUNTRY_TAX.REASON_TIN_NOT_ISSUED]: yup
        .string()
        .test(
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          () => {
            if (countryTax.filter(x => x.isTin === intl.formatMessage({ id: 'no' }) && x.reasonOption === 'REASON-B' && x.reasonNotIssued === '').length === 1) return false;
            return true;
          },
        ),
    }),
  ),
});


const countryTaxSchema = {
  countryTaxFieldsSchema,
  countryTaxListSchema,
};

export default countryTaxSchema;
